import { AfterContentInit, Component, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonColor } from '@freelancer/ui/button';

@Component({
  selector: 'app-navigation-secondary-my-skills',
  template: `
    <app-bar flTrackingSection="SubnavMySkills">
      <app-bar-item
        link="/jobs/myskills"
        i18n="Secondary navigation work bar item"
        flTrackingLabel="ProjectsWithMySkills"
      >
        Projects with My Skills
      </app-bar-item>
      <app-bar-item
        link="/jobs"
        [exactLink]="true"
        i18n="Secondary navigation work bar item"
        flTrackingLabel="BrowseProjects"
        [linkIsActive]="browseProjectsLinkActive"
      >
        Browse Projects
      </app-bar-item>
      <app-bar-item
        link="/contest/browse"
        i18n="Secondary navigation work bar item"
        flTrackingLabel="BrowseContests"
      >
        Browse Contests
      </app-bar-item>
      <app-bar-item
        link="/jobs/localjobs"
        [exactLink]="true"
        i18n="Secondary navigation work bar item"
        flTrackingLabel="BrowseLocalJobs"
      >
        Browse Local Jobs
      </app-bar-item>
      <app-bar-item
        link="/job"
        [exactLink]="true"
        i18n="Secondary navigation work bar item"
        flTrackingLabel="BrowseCategories"
      >
        Browse Categories
      </app-bar-item>
      <app-bar-item
        link="/jobs/bookmark"
        [exactLink]="true"
        i18n="Secondary navigation work bar item"
        flTrackingLabel="Bookmarks"
      >
        Bookmarks
      </app-bar-item>
      <fl-button
        [color]="ButtonColor.PRIMARY"
        link="/post-project"
        i18n="Secondary navigation work bar post project button"
        flTrackingLabel="PostProjectButton"
      >
        Post a Project
      </fl-button>
    </app-bar>
  `,
})
export class NavigationSecondaryMySkillsComponent
  implements OnChanges, AfterContentInit {
  ButtonColor = ButtonColor;
  browseProjectsLinkActive = false;

  constructor(private router: Router) {}

  ngOnChanges() {
    this.update();
  }

  ngAfterContentInit() {
    this.update();
  }

  private update() {
    // TODO T37479: This is needed in order for `routeLinkActive` to work when the nav is loaded
    // in compat mode (on PHP pages).
    const url =
      this.router.url === '/' ? document.location.pathname : this.router.url;
    // If the URL is any of the other specific /jobs pages (or /job) don't make
    // the Browse Projects link active.
    // This whole manual logic is because the hierarchy of the /jobs pages
    // are pretty unique. Can't do anything about it.
    if (
      !url.includes('/jobs/myskills') &&
      !url.includes('/jobs/localjobs') &&
      !url.includes('/jobs/bookmark') &&
      !(url.includes('/job') && !url.includes('/jobs')) &&
      url.includes('/jobs')
    ) {
      this.browseProjectsLinkActive = true;
    } else {
      this.browseProjectsLinkActive = false;
    }
  }
}
